import { render, staticRenderFns } from "./chat-message-replenishment.vue?vue&type=template&id=18806432&scoped=true"
import script from "./chat-message-replenishment.vue?vue&type=script&lang=js"
export * from "./chat-message-replenishment.vue?vue&type=script&lang=js"
import style0 from "./chat-message-replenishment.vue?vue&type=style&index=0&id=18806432&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18806432",
  null
  
)

export default component.exports